interface AvatarCircleProps {
  initials: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** People are circles (default); companies/orgs use 'square' (a rounded tile). */
  shape?: 'circle' | 'square';
}

const sizes = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-xs',
  lg: 'w-14 h-14 text-sm',
  xl: 'w-16 h-16 text-base',
};

/**
 * Initials monogram on a quiet, warm-neutral tile with a hairline border — the refined
 * Stripe/Ramp/Attio fallback look. Deliberately monochrome (all from design tokens, no generated
 * per-identity color) so a list of them stays calm and on-brand instead of reading as a rainbow.
 * People are circles (default); pass {@code shape="square"} for companies/orgs so they read
 * differently from people.
 */
export function AvatarCircle({ initials, size = 'md', shape = 'circle' }: AvatarCircleProps) {
  return (
    <div
      className={`${sizes[size]} ${shape === 'square' ? 'rounded-md' : 'rounded-full'} bg-secondary border border-border text-muted-foreground inline-flex items-center justify-center font-medium leading-none tracking-normal shrink-0`}
    >
      {initials}
    </div>
  );
}
